// Coordenação por ocorrência nesta sessão; não é idempotência no servidor.
export const mensagemIncerta = 'Não foi possível confirmar o protocolo. Os dados foram mantidos. Verifique a listagem de protocolos com a recepção antes de tentar registrar novamente, inclusive após recarregar ou em outra aba.';
export function idValido(id) {
  return (typeof id === 'number' || (typeof id === 'string' && /^[1-9]\d*$/.test(id))) && Number.isSafeInteger(Number(id)) && Number(id) > 0;
}
export function snapshotProtocolo(registro) {
  return JSON.parse(JSON.stringify({
    status: registro.status ?? null,
    protocolo_json: registro.protocolo_json ?? null,
    assinaturas_json: registro.assinaturas_json ?? null
  }));
}
export function criarPersistenciaQueda(http) {
  const operacoes = new Map();
  return function persistir(registro, payload, expected = null) {
    const chave = registro._tmpId || registro.id;
    if (!chave) return Promise.reject(new Error('Ocorrência sem identificação local.'));
    const anterior = operacoes.get(chave);
    if (anterior?.pendente) return anterior.pendente;
    if (anterior?.incerto) return Promise.reject(Object.assign(new Error(mensagemIncerta), { incerto: true }));
    if (idValido(registro.id) && !expected) return Promise.resolve(registro);
    if (expected && registro._controle_concorrencia !== 1) {
      return Promise.reject(new Error('A edição segura deste protocolo requer backend compatível. Atualize a aplicação e reabra o protocolo antes de assinar.'));
    }
    const criacao = !idValido(registro.id);
    const estado = {};
    operacoes.set(chave, estado);
    estado.pendente = (async () => {
      try {
        const resposta = idValido(registro.id)
          ? await http.put(`/operacional/alunos-quedas/${registro.id}`, { ...payload, expected })
          : await http.post('/operacional/alunos-quedas', payload);
        const row = resposta.data?.data || resposta.data;
        if (!idValido(row?.id) || (registro.id && Number(row.id) !== Number(registro.id))) {
          throw new Error(mensagemIncerta);
        }
        Object.assign(registro, row);
        if (criacao) registro._observacaoPendente = true;
        registro._snapshotProtocolo = snapshotProtocolo(row);
        return registro;
      } catch (erro) {
        // Somente a confirmação explícita do servidor permite uma nova tentativa.
        if (erro.response?.data?.persistencia === 'nao_realizada') {
          throw new Error(erro.response.data.error || 'Operação não realizada. Corrija os dados e tente novamente.');
        }
        estado.incerto = true;
        registro._resultadoIncerto = true;
        const incerto = new Error(mensagemIncerta);
        incerto.incerto = true;
        throw incerto;
      } finally {
        estado.pendente = null;
      }
    })();
    return estado.pendente;
  };
}
